module.exports = __webpack_public_path__ + "img/21_68.a5469f4b.png";